import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import Icon from "components/atoms/Icon";

export const BADGE_STYLE_TYPES = ["square", "round"];

const Badge = (props) => {
  const { children = "Badge", styleType = "square", iconType } = props;
  const componentBaseClass = "sal-badge";
  const componentClass = classnames(
    componentBaseClass,
    `${componentBaseClass}--${styleType}`,
  );

  const baseProps = {
    className: componentClass,
  };

  return (
    <span className={baseProps.className}>
      {iconType && (
        <Icon
          type={iconType}
          size="s"
          className={`${componentBaseClass}__icon`}
        />
      )}
      {children}
    </span>
  );
};

Badge.propTypes = {
  children: PropTypes.node,
  styleType: PropTypes.oneOf(BADGE_STYLE_TYPES),
  iconType: PropTypes.string,
};

export default Badge;
